import Vue from 'vue';

import { KeystrokeInputableTextId } from '@/components/keystrokeInputableText/KeystrokeInputableText';

type State = {
  keystrokeInputableTextId: KeystrokeInputableTextId | null;
};

// 現在のKeystrokeInputableTextIdを保持
const state = Vue.observable<State>({
  keystrokeInputableTextId: null,
});

export default Vue.extend({
  name: 'KeystrokeInputableTextMixin',

  computed: {
    keystrokeInputableTextId(): KeystrokeInputableTextId | null {
      return state.keystrokeInputableTextId;
    },
  },

  methods: {
    setKeystrokeId(id: KeystrokeInputableTextId | null): void {
      state.keystrokeInputableTextId = id;
    },
    async setFirstKeystrokeId(map: (KeystrokeInputableTextId | null)[][]): Promise<void> {
      const found = map.flatMap((row) => row).find((column) => column !== null);
      if (found === undefined) return;

      if (found !== null && this.keystrokeInputableTextId !== null && found.id === this.keystrokeInputableTextId.id) {
        // 現在のセルと初期セルが同じ場合、変更が検知されずフォーカスが当たらないため一度IDをnullに
        this.setKeystrokeId(null);
        await this.$nextTick();
      }
      this.setKeystrokeId(found);
    },
  },
});
